import React from 'react';
import { Create, SimpleForm, ReferenceInput, TextInput, SelectInput, required, minValue, maxValue, number } from 'react-admin';

const validateAmount = [required(), number()];
const validateLoyaltyPercentage = [required(), number(), minValue(1), maxValue(99)];
const LoyaltyProgramCreate = (props) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<TextInput source="ownerId" validate={required()} />
			<TextInput source="walletId" validate={required()} />
			<TextInput source="name" validate={required()} />
			<TextInput source="amount.amount" validate={validateAmount} />
			<ReferenceInput variant="standard" source="amount.currency" reference="currencies" validate={required()}>
				<SelectInput optionText="name" resettable />
			</ReferenceInput>
			<TextInput source="loyaltyPercentage" validate={validateLoyaltyPercentage} />
		</SimpleForm>
	</Create>
);

export default LoyaltyProgramCreate;
